import React from 'react';
import AddProfessionalForm from './AddProfessionalForm';
import { useAuth } from '../../utils/AuthContext/AuthContext'; // Assuming you have a useAuth hook
import config from '../../utils/config';

const AdminPage = () => {
  const { token, user } = useAuth();

  const handleAddProfessional = async (professionalFormData) => {
    // console.log('Payload:', professionalFormData); // Log the payload
    try {
        const response = await fetch(`${config.apiBaseUrl}/professionals`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(professionalFormData)
      });

      if (!response.ok) {
        throw new Error('Failed to add professional');
      }

      const data = await response.json();
      // console.log('Professional added:', data);
    } catch (error) {
      console.error('Error adding professional:', error);
    }
  };

  return (
    <div>
      <h1>Admin Page</h1>
      <AddProfessionalForm onSubmit={handleAddProfessional} />
    </div>
  );
};

export default AdminPage;